export enum UserRoleFilterFields {
	privilegeId = 'privilegeId',
	roleId = 'roleId'
}

export declare namespace UserRole {
	interface Basic {
		userId: number
		userName: string
		roleCode: string
		roleName: string
		privilegeCode: string
		privilegeName: string
		contactId: string
		contactName: string
		email: string
	}
}
